

<div class="app flex-row align-items-center">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">

        <img src="/assets/img/logo.png"/>

        <div class="card-group mb-4">
          <div class="card p-4">
            <div class="card-body">

              <div class="col-md-12 m-a-3">

                <div class="animated fadeIn">

                  <div class="row">

                    <br/>
                    <br/>

                    <div>
                      Account has been created. Please check your email:

                      <span [(ngModel)]="email">&#64;</span>
                    </div>

                    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; <button type="button" class="btn btn-link px-0" onclick="history.go(-1)">Back to login page</button>


                  </div>
                </div>

              </div>
            </div>



          </div>
        </div>
      </div>


    </div>
  </div>
</div>





